// Default namespace in i18next is "translation".
export const I18N_DEFAULT_NAMESPACE = 'translation';

export const CURRENCY_BY_LOCALE_MAP = {
  bg: 'BGN', // Bulgarian
  'bg-BG': 'BGN', // Bulgarian (Bulgaria)
  ca: 'EUR', // Catalan
  'ca-ES': 'EUR', // Catalan (Spain)
  cs: 'CZK', // Czech
  'cs-CZ': 'CZK', // Czech (Czech Republic)
  da: 'DKK', // Danish
  'da-DK': 'DKK', // Danish (Denmark)
  de: 'EUR', // German
  'de-CH': 'EUR', // German (Switzerland)
  'de-LU': 'EUR', // German (Luxembourg)
  'el-CY': 'EUR', // Greek (Cyprus)
  'el-GR': 'EUR', // Greek (Greece)
  en: 'USD', // English
  'en-AU': 'AUD', // English (Australia)
  'en-GB': 'GBP', // English (United Kingdom)
  'en-MT': 'EUR', // English (Malta)
  'en-NZ': 'NZD', // English (New Zealand)
  'en-SG': 'SGD', // English (Singapore)
  'en-US': 'USD', // English (United States)
  es: 'EUR', // Spanish
  'es-ES': 'EUR', // Spanish (Spain)
  'es-US': 'USD', // Spanish (United States)
  et: 'EUR', // Estonian
  'et-EE': 'EUR', // Estonian (Estonia)
  fi: 'EUR', // Finnish
  'fi-FI': 'EUR', // Finnish (Finland)
  fr: 'EUR', // French
  'fr-BE': 'EUR', // French (Belgium)
  'fr-CH': 'EUR', // French (Switzerland)
  'fr-LU': 'EUR', // French (Luxembourg)
  ga: 'EUR', // Irish
  'ga-IE': 'EUR', // Irish (Ireland)
  it: 'EUR', // Italian
  'it-CH': 'EUR', // Italian (Switzerland)
  'it-IT': 'EUR', // Italian (Italy)
  lt: 'EUR', // Lithuanian
  'lt-LT': 'EUR', // Lithuanian (Lithuania)
  lv: 'EUR', // Latvian
  'lv-LV': 'EUR', // Latvian (Latvia)
  mt: 'EUR', // Maltese
  'mt-MT': 'EUR', // Maltese (Malta)
  nl: 'EUR', // Dutch
  'nl-BE': 'EUR', // Dutch (Belgium)
  'nl-NL': 'EUR', // Dutch (Netherlands)
  no: 'NOK', // Norwegian
  'no-NO': 'NOK', // Norwegian (Norway)
  pl: 'PLN', // Polish
  'pl-PL': 'PLN', // Polish (Poland)
  pt: 'EUR', // Portuguese
  'pt-PT': 'EUR', // Portuguese (Portugal)
  ro: 'RON', // Romanian
  'ro-RO': 'RON', // Romanian (Romania)
  sk: 'EUR', // Slovak
  'sk-SK': 'EUR', // Slovak (Slovakia)
  sl: 'EUR', // Slovenian
  'sl-SL': 'EUR', // Slovenian (Slovenia)
  sv: 'SEK', // Swedish
  'sv-SE': 'SEK', // Swedish (Sweden)
  zh: 'HKD', // Chinese
  'zh-HK': 'HKD', // Chinese (Hong Kong)
  'zh-SG': 'SGD', // Chinese (Singapore)
} as { [key: string]: string };
